import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import BackLink from '../../../Components/BackLink'
import BookingForm from './BookingForm'
import { bookingSchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, booking, venues, packages }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${booking.booking_reference}`}
    >
      <BackLink href={`/manage/bookings/${booking.id}`}>Back to Booking</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={bookingSchema}
          resource="booking"
          endpoint={`/manage/bookings/${booking.id}`}
          method="patch"
          backLink={`/manage/bookings/${booking.id}`}
          submitLabel="Save Changes"
          defaultValues={{
            guest_name: booking.guest_name || '',
            guest_email: booking.guest_email || '',
            guest_phone: booking.guest_phone || '',
            date: booking.date || '',
            time: booking.time || '',
            party_size: booking.party_size || 1,
            venue_id: booking.venue_id || '',
            package_id: booking.package_id || '',
            total_pence: booking.total_pence || 0,
            notes: booking.notes || '',
            internal_notes: booking.internal_notes || ''
          }}
        >
          {({ control, errors }) => (
            <BookingForm
              control={control}
              errors={errors}
              venues={venues}
              packages={packages}
            />
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
